function submitFormRequired() {
    return true;
}
